function submitFormRequired() {
    return true;
}
